import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularKiteCoreModule } from '@kite/angular-kite';
import { AppComponent } from './app.component';
import { RootModule } from './store/root/root.module';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { ComponentLibraryModule } from '@srd/app-common-components';
import { httpInterceptorProviders } from './shared/interceptors/http.interceptors.provider';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    ComponentLibraryModule,
    AngularKiteCoreModule,
    RootModule,
  ],
  bootstrap: [AppComponent],
  providers: [httpInterceptorProviders],
})
export class AppModule {}
